import React from 'react';
import PropTypes from 'prop-types';

import {
    Col,
    Row,
} from '@zillow/zrs-comet';

import {
    Paragraph,
    Spacer,
    Text,
} from '@zillow/constellation';

import SvgTreeline from 'app/shared/images/treeline-illustration.svg';

import {
    StyledCard,
    StyledIconChevronRightCircle,
    StyledImageForSvg,
} from './StyledComponents';


const ApplicationSummaryCard = ({
    onApplicationSummaryClick,
    remainingCount,
    remainingCountNew,
    urlPath,
}) => {
    const handleCardClick = () => {
        onApplicationSummaryClick();
        window.router.updateLocation(urlPath);
    };

    const remainingApplicationsText = `+ ${remainingCount} applications...`;
    return (
        <StyledCard
            cardType="secondary"
            onClick={handleCardClick}
        >
            <Row>
                <Col>
                    <Paragraph
                        fontType="bodyHeading"
                    >
                        {remainingApplicationsText}
                    </Paragraph>
                </Col>
            </Row>

            <Row>
                <Col>
                    <Paragraph
                        paddingTop="xs"
                        paddingBottom="sm"
                    >
                        Includes

                        <Text fontColor="orange400" fontType="bodyHeading">
                            { ` ${remainingCountNew} new ` }
                        </Text>
                        applications.
                    </Paragraph>
                </Col>
            </Row>

            <Spacer paddingY="xs" />

            <Row>
                <Col xs={10}>
                    <StyledImageForSvg src={SvgTreeline} alt="background" />
                </Col>

                <Col xs={2}>
                    <StyledIconChevronRightCircle size="sm" />
                </Col>
            </Row>
        </StyledCard>
    );
};

ApplicationSummaryCard.propTypes = {
    remainingCount: PropTypes.number.isRequired,
    remainingCountNew: PropTypes.number.isRequired,
    urlPath: PropTypes.string.isRequired,
    onApplicationSummaryClick: PropTypes.func,
};

ApplicationSummaryCard.defaultProps = {
    onApplicationSummaryClick: () => {},
};

export default ApplicationSummaryCard;
